import React from 'react';
import { Flex, Input, Typography } from 'antd';

import { useTheme } from '../../../../hooks/useTheme';
import { ShopImageUpload } from '../../../shops/features/shops/components/ShopImageUpload';

const { TextArea } = Input;
const { Text } = Typography;

export const PersonalBroadcastsForm = ({ formik }) => {
    const { colorTextDescription } = useTheme();

    return (
        <Flex gap={24} vertical>
            <Flex gap={8} vertical>
                <Text>Текст</Text>
                <TextArea
                    rows={5}
                    autoSize={{
                        minRows: 3,
                        maxRows: 5,
                    }}
                    maxLength={1000}
                    value={formik?.values?.about}
                    onChange={event => {
                        formik.setFieldValue(`text`, event.target.value);
                    }}
                />
            </Flex>

            <Flex gap={8} vertical>
                <Text>Фото</Text>
                <ShopImageUpload
                    fieldName={'image'}
                    isEdit={false}
                    formik={formik}
                />
                <Text
                    style={{
                        color: colorTextDescription,
                        marginTop: '-12px',
                    }}
                >
                    Тип файлов: PNG, JPG, JPEG, GIF, вес до 10 МБ
                </Text>
            </Flex>
        </Flex>
    );
};
